import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=5326ffe6&scoped=true&"
import script from "./Ship.vue?vue&type=script&lang=js&"
export * from "./Ship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326ffe6",
  null
  
)

export default component.exports